export default function FilmGrain() {
  return <div className="grain-overlay" aria-hidden="true" />;
}
